var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Dialog',{attrs:{"title":_vm.title,"width":600,"isVisible":true,"isHideButton":true},on:{"cancel":_vm.close}},[_c('qrcode-vue',{attrs:{"value":_vm.hyperlink,"level":"H","size":"200"}}),_c('p',[_c('a',{attrs:{"href":_vm.hyperlink,"target":"_blank"}},[_vm._v(_vm._s(_vm.hyperlink))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }